import React, { useEffect, useRef, useState } from "react";
import Alert from "../../../common/elements/Alert";
import {
  StyledInfoMessage,
  StyledLink,
  StyledMessage,
  StyledSignInContainer,
  StyledTextFieldWrapper,
  StyledTimerText,
} from "../../LandingPage/Header/StyledComponent";
import {
  makeStyles,
  Popover,
  TextField,
  Grid,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import Button from "../../../common/elements/Button";
import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useDispatch } from "react-redux";
import Colors from "../../../common/materials/colors";
import AuthService from "../../../components/auth/AuthService";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import styled from "styled-components";
import {
  login,
  forgotPassword,
  resendOTP,
  signInOtop,
  resetPassword,
} from "../../LandingPage/Services";
import { redirectToOtherDomain } from "../../LandingPage/Utils";
import {
  getEmailFromUrlParams,
  joinedAuction,
  updateStore,
} from "../../LandingPage/Header/SignIn";
import ButtonComp from "../../../common/elements/Button";
import mixpanel from "mixpanel-browser";
import {
  getTimeZones,
  joinedAuctionsUrl,
  profileUrl,
} from "../../../common/config/app.endpoints";
import { StyledModal } from "../../auction/AuctionLivePageStyles";
import api, { setToken } from "../../../services/ApiService";
import auctions, { AuctionInvite } from "../../../services/ProductsApiService";
import { joinAuction } from "../../../common/GenericFunctions";
import PasswordResetViaOtp from "../../../modules/login/passwordReset/PasswordResetViaOtp";
import LoginWithEmail from "../../../modules/login/passwordReset/LoginWithEmail";
import NewPassword from "../../../modules/login/passwordReset/NewPassword";
import PaddleNumberModal from "../../../common/elements/PaddleNumberModal";
import SubdomainEditProfileForm from "../../../components/profile/SubdomainEditProfileForm";
import SignUpDialog from "../Dialogs/SignUp";
import SignUpFormDialog, {
  SignUpFormDialogOptions,
} from "../Dialogs/SignUpForm";
import { useDialog } from "../../../common/elements/Dialog/Dialog";
import { SignUpModalOptions } from "../../LandingPage/Dialogs/SignUp";

const StyledOtherOptionWrapper = styled(Grid)`
  @media screen and (max-width: 400px) {
    justify-content: center;
    gap: 5px;
    text-align: center;
  }
`;

const useStyles = makeStyles((theme) => ({
  asterisk: {
    color: Colors.red,
  },
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  input: {
    background: Colors.white,
  },
  margin: {
    margin: theme.spacing(1),
  },
  signInButton: {
    width: "44px",
    height: "44px",
    position: "relative",
  },
}));

const ForgetPassword = ({
  emailRef,
  otpSentForgotPassword,
  passwordRef,
  otpRef,
  newPasswordRef,
}: {
  emailRef: React.MutableRefObject<null>;
  passwordRef: React.MutableRefObject<null>;
  otpRef: React.MutableRefObject<null>;
  newPasswordRef: React.MutableRefObject<null>;
  otpSentForgotPassword: boolean;
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Grid container alignItems="center" justifyContent="center">
      {otpSentForgotPassword ? (
        <Grid alignItems="center" justifyContent="center">
          <StyledTextFieldWrapper
            fullWidth
            className={classes.margin}
            variant="outlined"
          >
            <TextField
              InputProps={{ className: classes.input }}
              classes={classes}
              label={t("common:profile:forgotPassword:labels:newPassword")}
              type="password"
              required
              inputRef={newPasswordRef}
              variant="outlined"
              id="new-password"
              autoComplete="off"
            />
          </StyledTextFieldWrapper>
          <StyledTextFieldWrapper
            fullWidth
            className={classes.margin}
            variant="outlined"
          >
            <TextField
              classes={classes}
              InputProps={{ className: classes.input }}
              label={t("common:profile:forgotPassword:labels:confirmPassword")}
              type="password"
              required
              inputRef={passwordRef}
              variant="outlined"
              id="old-password"
              autoComplete="off"
            />
          </StyledTextFieldWrapper>
          <Typography align="center" paragraph>
            {t("common:newLandingPage:otpText")}
          </Typography>
          <TextField
            InputProps={{ className: classes.input }}
            classes={classes}
            label={t("common:profile:forgotPassword:labels:otp")}
            type="text"
            required
            inputRef={otpRef}
            variant="outlined"
            id="otp"
            autoComplete="off"
          />
        </Grid>
      ) : (
        <StyledTextFieldWrapper fullWidth className={classes.margin}>
          <TextField
            type="email"
            label={t("common:login:labels:email")}
            inputRef={emailRef}
            variant="outlined"
            id="email"
          />
        </StyledTextFieldWrapper>
      )}
    </Grid>
  );
};

export const SignInForm = ({
  showSignInWithOTP,
  emailRef,
  passwordRef,
  otpRef,
  emailSubmitted,
}: {
  emailSubmitted: boolean;
  showSignInWithOTP: boolean;
  emailRef: React.MutableRefObject<null>;
  otpRef: React.MutableRefObject<null>;
  passwordRef: React.MutableRefObject<null>;
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [email, setEmail] = useState(getEmailFromUrlParams());
  const [showPassword, setShowPassword] = useState<Boolean>(false);

  const handleChange = (e: { target: { value: any } }) => {
    const value = e.target.value;
    setEmail(value);
  };

  return (
    <Grid container>
      {emailSubmitted ? null : (
        <StyledTextFieldWrapper
          fullWidth
          className={classes.margin}
          variant="outlined"
        >
          <TextField
            InputProps={{ className: classes.input }}
            type="email"
            label={t("common:login:labels:email")}
            inputRef={emailRef}
            variant="outlined"
            id="email"
            value={email}
            onChange={handleChange}
            autoComplete="off"
          />
        </StyledTextFieldWrapper>
      )}
      {showSignInWithOTP ? (
        emailSubmitted ? (
          <Grid container justifyContent="center">
            <Typography align="center" style={{ fontSize: "0.8em" }} paragraph>
              {t("common:newLandingPage:otpText")}
            </Typography>
            <TextField
              InputProps={{ className: classes.input }}
              classes={classes}
              label={t("common:profile:forgotPassword:labels:otp")}
              type="text"
              required
              inputRef={otpRef}
              variant="outlined"
              id="new-password"
              autoComplete="off"
            />
          </Grid>
        ) : null
      ) : (
        <StyledTextFieldWrapper
          fullWidth
          className={classes.margin}
          variant="outlined"
        >
          <TextField
            label={t("common:login:labels:password")}
            type={showPassword ? "text" : "password"}
            inputRef={passwordRef}
            variant="outlined"
            id="password"
            autoComplete="off"
            InputProps={{
              className: classes.input,
              endAdornment: (
                <>
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => {
                        setShowPassword(!showPassword);
                      }}
                      onMouseDown={() => {
                        setShowPassword(!showPassword);
                      }}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                </>
              ),
            }}
          />
        </StyledTextFieldWrapper>
      )}
    </Grid>
  );
};
type RouteParams = {
  auctionId: string;
  date: string;
};

export const ZipangSignIn = ({
  handleClose,
  setSuccessMessage,
  showForgotPassword = false,
  handleSignUpModal,
}: {
  showForgotPassword?: boolean;
  handleClose: any;
  setSuccessMessage?: any;
  handleSignUpModal: any;
  islanding?: boolean;
}) => {
  const { t } = useTranslation();
  const [showSignInWithOTP, setShowSignInWithOTP] = React.useState(false);
  const [showForgetPassword, setShowForgetPassword] =
    React.useState(showForgotPassword);
  const [emailSubmitted, setEmailSubmitted] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [otpSentForgotPassword, setOtpSentForgotPassword] =
    React.useState(false);
  const [message, setMessage] = React.useState("");
  const [infoMessage, setInfoMessage] = React.useState("");
  const [resetEnabled, setResetEnabled] = React.useState(true);
  const [timer, setTimer] = React.useState(30);
  const [subdomainName, setSubdomainName] = React.useState("");
  const emailRef = useRef<any>(null);
  const passwordRef = useRef<any>(null);
  const forgotEmailRef = useRef<any>(null);
  const otpRef = useRef<any>(null);
  const newPasswordRef = useRef<any>(null);
  const [profileData, setProfileData] = useState<any>();
  const [isEditProfile, setIsEditProfile] = useState(false);
  const [showNewPasswordPopup, setShowNewPasswordPopup] = useState(false);
  const [timezone, setTimezone] = useState("");
  // const [showOTPPopup, setShowOTPPopup] = useState(false);
  // const [isChangePlan, setIsChangePlan] = useState(false);
  const { auctionId, date } = useParams<RouteParams>();
  // let invitedinfo: any = null;
  const [isPaddle, setIsPaddle] = useState<boolean>(false);
  const handleForgetPassword = () => {
    setMessage("");
    setShowForgetPassword(true);
  };
  const dispatch = useDispatch();
  const history = useHistory();

  const validateEmail = (email: string) =>
    new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,20}/g).test(email);

  const emailValidations = (email: string, password: string) => {
    const validEmail = validateEmail(email);
    if (email === "") {
      return t("common:register:errorMessage:emptyEmail");
    } else if (!validEmail) {
      return `${t("common:register:errorMessage:newonEmail")}`;
    } else if (email === "" && password === "") {
      return `${t("common:allValidations:emptyFields")}`;
    } else if (password === "") {
      return `${t("common:login:validation:invalidEmailorPassword")}`;
    }
    return "";
  };

  useEffect(() => {
    setTimeout(() => {
      setInfoMessage("");
    }, 2000);
  }, [infoMessage]);
  const getProfile = async () => {
    return new Promise((resolve, reject) => {
      Auth.getRequest(profileUrl, (status: number, response: any) => {
        if (status === 200 && response !== undefined) {
          setProfileData(response);
          localStorage.setItem("isReadOnlyUser", response.readOnlyUser);
          localStorage.setItem("paddleNumber", response.paddleNumber);
          var timeZone = "";
          if (response.timezone) {
            localStorage.setItem("timezoneName", response.timezone.name);
            timeZone = response.timezone.name;
          }
          localStorage.setItem(
            "defaultPasswordUpdated",
            response.defaultPasswordUpdated
          );
          localStorage.setItem("userFirstName", response.firstName);
          localStorage.setItem("userLastName", response.lastName);
          localStorage.setItem("userEmail", response.email);
          localStorage.setItem("userType", response.userType);
          localStorage.setItem(
            "profileComplete",
            response.defaultPasswordUpdated
          );
          localStorage.setItem("isReadOnlyUser", response.readOnlyUser);
          localStorage.setItem("paddleNumber", response.paddleNumber);
          localStorage.setItem("userUniqueId", response.uniqueId);
          localStorage.setItem("companyName", response.companyName);
          localStorage.setItem(
            "userCountry",
            response.countryDetail !== undefined
              ? response.countryDetail.name
              : ""
          );
          localStorage.setItem("userIdForNotification", response.perId);
          localStorage.setItem("userIdForNotification", response.perId);
          if (response.preferredCurrency) {
            localStorage.setItem(
              "preferredCurrency",
              response.preferredCurrency.code
            );
            localStorage.setItem(
              "preferredCurrencySymbol",
              response.preferredCurrency.symbol
            );
          } else {
            localStorage.setItem("preferredCurrency", "JPY");
            localStorage.setItem("preferredCurrencySymbol", "¥");
          }
          PubSub.publish("ProfileStatus", "Yes");
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  };
  const joinAuction = async () => {
    Auth.getRequest(joinedAuctionsUrl, (status: any, response: any) => {
      if (status === 200) {
        if (response !== undefined) {
          localStorage.setItem(
            "joinedAuctions",
            JSON.stringify(response.results)
          );
        }
      }
    });
  };

  // const processLoginResponse = async (status: number, response: any) => {
  //   if (status === 200) {
  //     updateStore(dispatch);
  //     const token = localStorage.getItem("id_token");
  //     if (token) {
  //       setToken(token);
  //     }
  //     const auctionlist = await auctions();
  //     // if (!auctionlist?.results || auctionlist.results.length === 0) {
  //     //   alert("Ongoing Auctions is not present");
  //     //   return;
  //     // }
  //     if (auctionlist.results.length !== 0) {
  //       const {
  //         auctionType,
  //         id: auctionId,
  //         auctionUserId,
  //         name: auctionName,
  //         startDate: auctionDate,
  //       } = auctionlist.results[auctionlist.results.length - 1];
  //       const invitedinfo = await AuctionInvite(auctionId);
  //     }
  //     const redirectPath = localStorage.getItem("postLoginRedirect");
  //     await getProfile();
  //     await joinAuction();
  //     if (redirectPath) {
  //       localStorage.setItem("userId", invitedinfo.data.auctionUserId);
  //       localStorage.removeItem("postLoginRedirect");
  //       window.location.href = redirectPath; // Redirect user after login
  //       //history.replace(redirectPath); // Redirect user after login
  //     } else {
  //       let pathname = window.location.pathname;
  //       window.location.href = pathname; // Default redirect path
  //     }
  //     // call joined auction function here. add the function to the services method and add callback here.
  //     joinedAuction(history);

  //     return;
  //   }
  //   if (status > 200 && status < 500) {
  //     if (response[0].code !== undefined) {
  //       if (response[0].code === "KB409001") {
  //         setMessage(
  //           `${t("common:register:errorMessage:profileVerification")}`
  //         );
  //       } else if (response[0].code === "KB412004") {
  //         setMessage(
  //           `${t("common:login:validation:newinvalidEmailorPassword")}`
  //         );
  //       } else if (response[0].code === "KB401002") {
  //         setMessage(`${t("common:login:validation:registeredAsAuctioneer")}`);
  //       } else if (response[0].code === "KB412003") {
  //         setMessage(
  //           `${t("common:profile:forgotPassword:validation:newinvalidOTP")}`
  //         );
  //       } else if (response[0].code === "KB404001") {
  //         setMessage(
  //           `${t("common:login:validation:newinvalidEmailorPassword")}`
  //         );
  //       } else if (response[0].code === "KB401004") {
  //         setMessage(``);
  //         localStorage.setItem("changePlanEmail", emailRef.current?.value);
  //         setSubdomainName(response[0].field);
  //       } else if (response[0].code === "KB401005") {
  //         setMessage(`You don't have any invitation to access.`);
  //       } else {
  //         setMessage(`${t("common:invalidRequest")}`);
  //       }
  //     }
  //   } else if (status === 500) {
  //     setMessage(response[0].message);
  //   }
  // };
  const getTimeZone = () => {
    Auth.getRequest(getTimeZones, (status: number, response: any) => {
      if (status === 200) {
        if (response !== undefined) {
          setTimezone(response);
        }
      }
    });
  };

  const processLoginResponse = async (status: number, response: any) => {
    if (status === 200) {
      updateStore(dispatch);

      const token = localStorage.getItem("id_token");
      if (token) {
        setToken(token);
      }
      getTimeZone();
      await getProfile();
      const auctionlist = await auctions();
      let invitedinfo: any = null;
      if (auctionlist?.results?.length) {
        const {
          auctionType,
          id: auctionId,
          auctionUserId,
          name: auctionName,
          startDate: auctionDate,
        } = auctionlist.results[auctionlist.results.length - 1];
        const defaultpassword = localStorage.getItem("defaultPasswordUpdated");
        if (defaultpassword === "true") {
          invitedinfo = await AuctionInvite(auctionId);
        }
      }

      const redirectPath = localStorage.getItem("postLoginRedirect");

      await joinAuction();
      const profileComplete = localStorage.getItem("profileComplete");
      if (profileComplete === "false" || profileComplete === null) {
        setShowNewPasswordPopup(true);
        return;
      }
      if (redirectPath) {
        if (invitedinfo?.data?.auctionUserId) {
          localStorage.setItem("userId", invitedinfo.data.auctionUserId);
        }
        localStorage.removeItem("postLoginRedirect");
        window.location.href = redirectPath;
      } else {
        const pathname = window.location.pathname;
        if (
          pathname.includes("sell") ||
          pathname.includes("team-page") ||
          pathname.includes("zipangAuctionslist")
        ) {
          history.replace("/home");
        } else {
          window.location.href = pathname;
        }
      }

      joinedAuction(history); // Call after redirect setup
      return;
    }

    if (status > 200 && status < 500 && Array.isArray(response)) {
      const code = response[0]?.code;

      switch (code) {
        case "KB409001":
          setMessage(t("common:register:errorMessage:profileVerification"));
          break;
        case "KB412004":
        case "KB404001":
          setMessage(t("common:login:validation:newinvalidEmailorPassword"));
          break;
        case "KB401002":
          setMessage(t("common:login:validation:registeredAsAuctioneer"));
          break;
        case "KB412003":
          setMessage(
            t("common:profile:forgotPassword:validation:newinvalidOTP")
          );
          break;
        case "KB401004":
          setMessage("");
          localStorage.setItem(
            "changePlanEmail",
            emailRef.current?.value || ""
          );
          setSubdomainName(response[0]?.field || "");
          break;
        case "KB401005":
          setMessage("You don't have any invitation to access.");
          break;
        default:
          setMessage(t("common:invalidRequest"));
          break;
      }
    } else if (status === 500 && Array.isArray(response)) {
      setMessage(response[0]?.message || "Internal server error");
    }
  };

  const handleLogin = async () => {
    let username = emailRef.current?.value;
    if (username !== null) {
      username = username.toLowerCase();
    }
    const password = passwordRef.current?.value;
    const errorMessage = emailValidations(username, password);
    setMessage(errorMessage);
    //temp zipang logo fix
    localStorage.setItem("isZipangDomain", "true");
    localStorage.setItem("isGlowstarDomain", "false");
    // Set this to a unique identifier for the user performing the event.
    mixpanel.identify(username);

    // // Track an event. It can be anything, but in this example, we're tracking a Sign Up event.
    mixpanel.track("Sign Up", {
      "Signup Type": "Referral",
    });
    mixpanel.people.set({
      $email: username,
      $name: username,
    });

    mixpanel.track("User Login");

    if (!errorMessage) {
      const { status, response } = await login({ username, password });
      localStorage.setItem("email", username);
      processLoginResponse(status, response);
    }
  };

  const handleForgotPasswordEmailSubmit = async (_email?: string) => {
    setMessage("");
    setInfoMessage("");
    let email = forgotEmailRef.current?.value || _email;
    if (typeof email === "string" && email.trim() !== "") {
      email = email.toLowerCase();
    }
    const validEmail = validateEmail(email);
    if (validEmail) {
      setIsLoading(true);
      const { status, response } = await forgotPassword(email.toLowerCase());
      setIsLoading(false);
      if (status === 200) {
        localStorage.setItem("email", email.toLowerCase());
        setInfoMessage(response.data.message);
        setOtpSentForgotPassword(true);
      } else if (status > 200 && status < 500) {
        if (response[0].code === "KB404001") {
          setIsLoading(false);
          setMessage(
            `${t(
              "common:profile:forgotPassword:validation:notRegisteredEmail"
            )}`
          );
        }
      } else {
        setIsLoading(false);
      }
    } else {
      setMessage(`${t("common:register:errorMessage:onEmail")}`);
    }
  };

  const handleSendCode = async (email: string) => {
    setIsLoading(true);
    const { status, response } = await resendOTP(email.toLowerCase());
    if (status > 200 && status < 500) {
      if (response[0].code === "KB404001") {
        setIsLoading(false);
        setMessage(
          `${t("common:profile:forgotPassword:validation:notRegisteredEmail")}`
        );
        return false;
      }
    }
    setIsLoading(false);
    return true;
  };

  const showSignInWithOTPState = () => {
    setMessage("");
    setShowSignInWithOTP(true);
  };

  const handleEmailSubmitOfOTPLogin = async () => {
    setMessage("");
    let email = emailRef.current?.value;
    if (email === "") {
      return setMessage(t("common:register:errorMessage:emptyEmail"));
    }
    if (email !== null) {
      email = email.toLowerCase();
    }
    const validEmail = validateEmail(email);
    if (validEmail) {
      localStorage.setItem("email", email);
      const success = await handleSendCode(email);
      success && setEmailSubmitted(true);
    } else {
      setMessage(t("common:register:errorMessage:onEmail"));
    }
  };

  const handleLoginWithOTP = async () => {
    const otp = otpRef.current.value;
    const email: any = localStorage.getItem("email");
    localStorage.setItem("changePlanEmail", email);
    const { status, response } = await signInOtop({
      username: email.toLowerCase(),
      password: otp,
      type: "OTP",
    });

    mixpanel.identify(email);

    // // Track an event. It can be anything, but in this example, we're tracking a Sign Up event.
    mixpanel.track("Sign Up", {
      "Signup Type": "Referral",
    });
    mixpanel.people.set({
      $email: email,
      $name: email,
    });

    mixpanel.track("User OTP Login");

    if (status === 200) {
      Auth.setToken(response.token);
      localStorage.setItem("otpAuth", "true");
    }
    processLoginResponse(status, response);
  };

  const handleReSendCode = async () => {
    setResetEnabled(false);
    const email = emailRef.current?.value || localStorage.getItem("email");
    if (!email) {
      setMessage(`${t("common:register:errorMessage:onEmail")}`);
      return;
    }
    const success = await (showForgetPassword
      ? forgotPassword(email.toLowerCase())
      : handleSendCode(email.toLowerCase()));
    if (success) {
      setOtpSentForgotPassword(true);
    } else {
      setOtpSentForgotPassword(false);
    }
  };

  const handleNewPassword = async () => {
    let digits = /^[0-9]+$/;
    const otp = otpRef.current.value;
    let newPasswordVariable = newPasswordRef.current?.value?.trim();
    let confirmPasswordVariable = passwordRef.current?.value?.trim();
    let email = localStorage.getItem("email") || "";
    if (newPasswordVariable === "") {
      return setMessage(
        `${t("common:profile:changePassword:validation:enterNewPassword")}`
      );
    } else if (confirmPasswordVariable === "") {
      return setMessage(
        `${t("common:profile:changePassword:validation:enterOldPassword")}`
      );
    } else if (newPasswordVariable !== confirmPasswordVariable) {
      return setMessage(
        `${t("common:profile:validation:newAndConfirmPasswordNotMatch")}`
      );
    } else if (email === null || email === "") {
      return setMessage(
        `${t("common:profile:forgotPassword:validation:notRegisteredEmail")}`
      );
    } else if (!otp.match(digits)) {
      return setMessage(
        `${t("common:profile:forgotPassword:validation:correctOTP")}`
      );
    }
    setIsLoading(true);
    const { status, response } = await resetPassword(
      email.toLowerCase(),
      newPasswordVariable,
      otp
    );

    setIsLoading(false);

    if (status === 200) {
      handleClose();
      setSuccessMessage && setSuccessMessage(response.data.message);
    } else if (status > 200 && status < 500) {
      if (response[0].code !== undefined) {
        if (response[0].code === "KB412003") {
          setMessage(
            `${t("common:profile:forgotPassword:validation:invalidOTP")}`
          );
        } else {
          setMessage(response[0].message);
        }
      } else {
        setMessage(response[0].message);
      }
    } else {
      setMessage(response.data.message);
    }
  };
  //changePlane Value
  // const rhandlechangePlanModal = (val: string) => {
  //   setSubdomainName(val);
  //   setIsChangePlan(true);
  // };

  useEffect(() => {
    if (!resetEnabled) {
      setTimeout(() => {
        setResetEnabled(true);
      }, 30000);
    }
  }, [resetEnabled]);

  useEffect(() => {
    if (timer === 0) {
      setResetEnabled(true);
    }
    if (!resetEnabled) {
      setTimeout(() => {
        setTimer(timer - 1);
      }, 1000);
    }
  }, [resetEnabled, timer]);
  // const rhandlechangePlanModal = (val: string) => {
  //   subdomainName = val;
  //   setIsChangePlan(true);
  // };
  // const renderResetPasswordPopup = () => {
  //   return (
  //     <StyledModal
  //       open={showResetPasswordPopup}
  //       onClose={() => {
  //         setShowResetPasswordPopup(false);
  //       }}
  //     >
  //       <LoginWithEmail
  //         closeModal={() => {
  //           setShowResetPasswordPopup(false);
  //         }}
  //         isFromSubDomain={false}
  //         renderOTPPopup={() => {
  //           setShowOTPPopup(true);
  //           setShowResetPasswordPopup(false);
  //         }}
  //         subdomainfunc={rhandlechangePlanModal} // if you don’t need subdomain logic, you can remove this
  //       />
  //     </StyledModal>
  //   );
  // };

  // const renderOTPPopup = () => {
  //   return (
  //     <StyledModal open={showOTPPopup}>
  //       <PasswordResetViaOtp
  //         closeOtpModal={() => {
  //           setShowOTPPopup(false);
  //         }}
  //         openPasswordPop={() => {
  //           setShowResetPasswordPopup(true);
  //         }}
  //       />
  //     </StyledModal>
  //   );
  // };

  const renderSDEditForm = () => {
    setShowNewPasswordPopup(false);
    setIsEditProfile(true);
  };
  const onOpenPaddleModal = async () => {
    getProfile();
    setIsPaddle(true);

    setTimeout(async () => {
      // 👈 mark callback async
      setIsPaddle(false);

      const redirectPath = localStorage.getItem("postLoginRedirect");
      console.log("redirectPath", redirectPath);

      if (redirectPath) {
        try {
          // 👇 make sure auctionId is available here
          const invitedinfo = await AuctionInvite(auctionId);

          if (invitedinfo?.data?.auctionUserId) {
            localStorage.setItem("userId", invitedinfo.data.auctionUserId);
          }

          localStorage.removeItem("postLoginRedirect");
          window.location.href = redirectPath;
        } catch (err) {
          console.error("AuctionInvite failed:", err);
        }
      } else {
        const pathname = window.location.pathname;

        if (
          pathname.includes("sell") ||
          pathname.includes("team-page") ||
          pathname.includes("zipangAuctionslist")
        ) {
          history.replace("/home");
        } else {
          window.location.href = pathname;
        }
      }
    }, 3000);
  };

  const renderPaddleNumberModal = () => {
    return (
      <StyledModal
        open={isPaddle}
        onClose={() => setIsPaddle(false)}
        className="PaddleNumber"
      >
        <PaddleNumberModal
          closeModal={() => setIsPaddle(false)}
          {...profileData}
        />
      </StyledModal>
    );
  };
  const closeModal = () => {
    Auth.logout();
    history.replace("/");
  };

  function setAnchorEl(arg0: null) {
    throw new Error("Function not implemented.");
  }

  return (
    <>
      <Grid container justifyContent="space-between" alignItems="center">
        {showNewPasswordPopup === true && (
          <StyledModal open={showNewPasswordPopup}>
            <NewPassword
              onClose={() => {
                setShowNewPasswordPopup(false);
              }}
              onShowPaddleNoModal={() => {
                getProfile();
                onOpenPaddleModal();
              }}
              subDomainPage={() => renderSDEditForm()}
            />
          </StyledModal>
        )}
        {isEditProfile && (
          <StyledModal
            open={isEditProfile}
            onClose={() => closeModal()}
            className="registerModal"
          >
            <SubdomainEditProfileForm
              {...profileData}
              t={t}
              closeModal={() => {
                setIsEditProfile(false);
                // getProfile();
                onOpenPaddleModal();
              }}
              // saveProfile={() => getProfile()}
              openPaddleModal={onOpenPaddleModal}
              timeZone={timezone}
            />
          </StyledModal>
        )}
        {isPaddle && renderPaddleNumberModal()}
        {showForgetPassword ? (
          <ForgetPassword
            emailRef={forgotEmailRef}
            passwordRef={passwordRef}
            newPasswordRef={newPasswordRef}
            otpRef={otpRef}
            otpSentForgotPassword={otpSentForgotPassword}
          />
        ) : (
          <SignInForm
            otpRef={otpRef}
            emailSubmitted={emailSubmitted}
            showSignInWithOTP={showSignInWithOTP}
            emailRef={emailRef}
            passwordRef={passwordRef}
          />
        )}

        <Grid container>
          <StyledMessage>{message}</StyledMessage>
          <StyledInfoMessage>{infoMessage}</StyledInfoMessage>
        </Grid>

        {showForgetPassword && (
          <Grid container justifyContent="space-between">
            {!otpSentForgotPassword && (
              <Button
                disabled={isLoading}
                type="contained-red"
                noMargin
                onClick={handleForgotPasswordEmailSubmit}
              >
                {t("common:kycFrom:submit")}
              </Button>
            )}
            {otpSentForgotPassword && (
              <Button
                disabled={isLoading}
                type="contained-red"
                noMargin
                onClick={handleNewPassword}
              >
                {t("common:profile:forgotPassword:button:update")}
              </Button>
            )}
            {otpSentForgotPassword && resetEnabled && (
              <StyledLink onClick={handleReSendCode}>
                {t("common:button:resendOtp")}
              </StyledLink>
            )}
            {!resetEnabled && (
              <StyledTimerText>
                {" "}
                {t("common:button:resendOtpText")} {timer} &nbsp;
                {t("common:button:resendOtpSeconds")}
              </StyledTimerText>
            )}
          </Grid>
        )}
        {!showForgetPassword && (
          <StyledOtherOptionWrapper
            container
            justifyContent="space-between"
            alignItems="center"
          >
            {showSignInWithOTP && !emailSubmitted && (
              <Grid>
                <Button
                  disabled={isLoading}
                  type="contained-red"
                  noMargin
                  onClick={handleEmailSubmitOfOTPLogin}
                >
                  {t("common:kycFrom:submit")}
                </Button>
              </Grid>
            )}
            {showSignInWithOTP && emailSubmitted && (
              <Grid container justifyContent="space-between">
                <Button
                  disabled={isLoading}
                  type="contained-red"
                  noMargin
                  onClick={handleLoginWithOTP}
                >
                  {t("common:header:buttons:login")}
                </Button>

                {resetEnabled ? (
                  <StyledLink onClick={handleReSendCode}>
                    {t("common:button:resendOtp")}
                  </StyledLink>
                ) : (
                  <StyledTimerText>
                    {t("common:button:resendOtpText")} ({timer}{" "}
                    {t("common:button:seconds")})
                  </StyledTimerText>
                )}
              </Grid>
            )}
            {!showSignInWithOTP && !emailSubmitted && (
              <Button type="contained-red" noMargin onClick={handleLogin}>
                {t("common:login:title")}
              </Button>
            )}
            {!showSignInWithOTP && emailSubmitted && (
              <Button
                type="contained-red"
                noMargin
                onClick={handleLoginWithOTP}
              >
                {t("common:login:title")}
              </Button>
            )}
            <div>
              {!showSignInWithOTP && (
                <StyledLink onClick={showSignInWithOTPState}>
                  {t("common:button:otpSignIn")}
                </StyledLink>
              )}
              <br />
              {!showSignInWithOTP && (
                <StyledLink
                  onClick={() => {
                    //TODO: Close Login Modal Here
                    handleClose();
                    handleSignUpModal();
                  }}
                >
                  {t("common:newUserSignUp")}
                </StyledLink>
              )}
              <br />
              {/* {!showSignInWithOTP && (
                <StyledLink onClick={() => redirectToOtherDomain("auctioneer")}>
                  {t("common:button:signInAsAuction")}
                </StyledLink>
              )}
              <br /> */}
              {!showSignInWithOTP && (
                <StyledLink onClick={handleForgetPassword}>
                  {t("common:login:forgotPassword")}
                </StyledLink>
              )}
            </div>
          </StyledOtherOptionWrapper>
        )}
      </Grid>
      {/* {showResetPasswordPopup && renderResetPasswordPopup()}
      {showOTPPopup && renderOTPPopup()} */}
    </>
  );
};
const Auth = new AuthService();
const HeaderSignInMenu = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [createDialog, closeDialog] = useDialog();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [message, setMessage] = useState("");
  const menuSpace = useRef(null);

  const handleClick = () => {
    setAnchorEl(menuSpace.current);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  /* const handleBuyDiamonds = React.useCallback(
    (isMobile) => {
      createDialog({
        children: (
          <SignUpFormDialog
            isMobile={isMobile}
            onSignUp={closeDialog}
            close={closeDialog}
          />
        ),
        ...SignUpFormDialogOptions,
      });
    },
    [isMobile]
  ); */

  //Open SignUp Modal
  const handleSignUpModal = React.useCallback(
    (isMobile) => {
      createDialog({
        children: (
          <SignUpFormDialog
            isMobile={isMobile}
            onSignUp={closeDialog}
            close={closeDialog}
            islanding={true}
          />
        ),
        ...SignUpModalOptions,
      });
    },
    [isMobile]
  );

  useEffect(() => {
    const userEmail = getEmailFromUrlParams();
    if (userEmail) {
      handleClick();
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setMessage("");
    }, 3000);
  }, [message]);

  const isLoggedInUser = Auth.loggedIn();
  let { t } = useTranslation();
  return (
    <div>
      <ButtonComp onClick={handleClick} type="contained-login-red">
        {message && <Alert showAlertMessage={message} alertType={""} />}
        <span id="sign-in">{t("common:header:buttons:loginNew")}</span>
      </ButtonComp>
      <div>
        <span ref={menuSpace}></span>
        {isLoggedInUser ? null : (
          <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={handleClose}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          >
            <StyledSignInContainer elevation={3}>
              <ZipangSignIn
                handleClose={handleClose}
                setSuccessMessage={setMessage}
                handleSignUpModal={handleSignUpModal}
                islanding={true}
              />
            </StyledSignInContainer>
          </Popover>
        )}
      </div>
    </div>
  );
};

export default React.memo(HeaderSignInMenu);
function createDialog(arg0: any) {
  throw new Error("Function not implemented.");
}
